<template>
  <div class="st-form-item" :st-form-item-prop="prop" :required="required">
    <p :class="`st-van-filed-label  ${(required ? 'st-required' : '')}`">{{ label }}</p>
    <slot></slot>
    <div class="st-err-msg err-hide">不能为空</div>
  </div>
</template>


<script>
export default {
  components: {},
  props: {
    label: {
      type: String,
      default: () => {
        return '';
      }
    },
    prop: {
      type: String,
      default: () => {
        return '';
      }
    },
    required: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      result: '',
      error: '',
    }
  },
  created() {

  },
  methods: {
    
  }

}
</script>

<style lang="scss" scoped>
  .st-form-item {
    .st-van-filed-label.st-required {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }

    .st-err-msg {
      color: #ee0a24;
      font-size: 12px;
      padding: 4px 15px;
      font-weight: 400;
    }
    .err-show {
      display: block;
    }

    .err-hide {
      display: none;
    }

  }
  
	[disabled="disabled"] {
		pointer-events: none;
	}
</style>
